import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

import { AuthLayout } from "src/layouts/AuthLayout";
import { useNavigate } from "react-router-dom";
import { PasswordForgotForm, PasswordForgotFormData } from "src/forms/PasswordForgotForm";
import { usePasswordForgotMutation } from "src/hooks/usePasswordForgotMutation";

export function PasswordForgotPage(props: {}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const passwordForgotMutation = usePasswordForgotMutation();

  function handleClose() {
    navigate("/login");
  }

  async function handleSubmit(values: PasswordForgotFormData) {
    passwordForgotMutation.mutateAsync(values);
    enqueueSnackbar(t("label.anEmailWillBeSent"), {
      variant: "info",
    });
    navigate("/login");
  }

  return render();

  function render() {
    return (
      <AuthLayout>
        <StyledBox height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Box pb={3}>
            <Typography variant="h3" component="h1">
              {t("label.forgotYourPassword")}
            </Typography>
            <Typography variant="subtitle1" component="h1">
              {t("label.provideYourEmailAddress")}
            </Typography>
          </Box>

          <PasswordForgotForm
            onClose={handleClose}
            onSubmit={handleSubmit}
            errors={passwordForgotMutation.error}
            isLoading={passwordForgotMutation.isLoading}
          />
          {/* <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, actions) => {
              setServerErrors([]);

              const result = await password.request(values.email);
              if (result.isOk()) {
                enqueueSnackbar(t("label.anEmailWillBeSent"), {
                  variant: "info",
                });
                navigate("/login");
              } else {
                const error = result.error.shift();
                if (error) {
                  enqueueSnackbar(parseServerError(error), {
                    variant: "error",
                  });
                }
              }
            }}
          >
            {({ isSubmitting, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      component={TextField}
                      label={t("label.email")}
                      name="email"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ServerErrors data={serverErrors} />
                  </Grid>
                </Grid>

                <ButtonGrid container item xs={12} justify="flex-start">
                  <ButtonLoading type="submit" isLoading={isSubmitting}>
                    {t("label.submit")}
                  </ButtonLoading>

                  <Button
                    variant="text"
                    disabled={isSubmitting}
                    onClick={handleCancel}
                  >
                    {t("label.cancel")}
                  </Button>
                </ButtonGrid>
              </Form>
            )}
          </Formik> */}
        </StyledBox>
      </AuthLayout>
    );
  }
}

const StyledBox = styled(Box)`
  margin: 0 auto;

  ${({ theme }) => `
  padding: ${theme.spacing(8)};
  `}
`;
